<template>
	<ui-card icon="fal fa-digging" title="Página em Construção">
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div v-show="loader.body" class="loading-area">
				<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
			</div>

			<div v-show="!loader.body">Nada pronto por aqui...</div>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-button design="md primary" :disabled="true">Salvar o que?</ui-button>
		</template>
	</ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput } from '@/components/ui/form'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	const defaultForm = () => ({})
	const defaultDisabled = () => ({})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		components: { uiCard, uiButton, uiInput, uiLoadSuccess, uiLoadIndicator },

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				loader: { ...defaultLoader() },
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
